import React from 'react';
import {
    Box,
    Card,
    CardContent,
    Typography,
    Button,
    Divider,
    Alert
} from '@mui/material';
import { AccountBalance, Add } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

const BankAccountManagement: React.FC = () => {
    const navigate = useNavigate();

    return (
        <Box maxWidth={800} mx="auto" mt={4} px={2}>
            <Card>
                <CardContent sx={{ p: 4 }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', mb: 3 }}>
                        <AccountBalance sx={{ fontSize: 32, color: 'secondary.main', mr: 2 }} />
                        <Typography variant="h4" sx={{ fontWeight: 600 }}>
                            Bank Account Management
                        </Typography>
                    </Box>
                    
                    <Divider sx={{ mb: 3 }} />

                    <Alert severity="info" sx={{ mb: 3 }}>
                        This feature is currently under development. You will be able to add, edit, and manage your bank accounts here.
                    </Alert>

                    <Box sx={{ textAlign: 'center', py: 4 }}>
                        <Typography variant="h6" color="text.secondary" sx={{ mb: 2 }}>
                            Coming Soon
                        </Typography>
                        <Typography variant="body1" color="text.secondary" sx={{ mb: 4 }}>
                            We're working on bringing you a comprehensive bank account management system.
                        </Typography>
                        
                        <Box sx={{ display: 'flex', gap: 2, justifyContent: 'center' }}>
                            <Button
                                variant="contained"
                                startIcon={<Add />}
                                disabled
                            >
                                Add Bank Account
                            </Button>
                            <Button
                                variant="outlined"
                                onClick={() => navigate('/profile')}
                            >
                                Back to Profile
                            </Button>
                        </Box>
                    </Box>
                </CardContent>
            </Card>
        </Box>
    );
};

export default BankAccountManagement; 